/* unplugin-vue-components disabled */import { render } from "./footer-bar.vue?vue&type=template&id=7d2ccc9e&scoped=true"
import script from "./footer-bar.vue?vue&type=script&lang=js"
export * from "./footer-bar.vue?vue&type=script&lang=js"

import "./footer-bar.vue?vue&type=style&index=0&id=7d2ccc9e&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/offical-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2ccc9e"]])

export default __exports__